import { useEffect, useMemo, useState } from "react";
import { CompetitionConsentNames, CompetitionInputNames } from "shared/modals/competitionLegalsModal/types";
import { AppTester } from "supporting";

const commonFields = [CompetitionInputNames.PROJECT_ID, CompetitionInputNames.NOMINATION_ID]

export const useCompetitionFormField = (competitionId: string): [CompetitionInputNames[], CompetitionConsentNames[]] => {
    const [fields, setFields] = useState<CompetitionInputNames[]>([

    ])
    const isDamuseum = AppTester.isDaMuseum();

  const isVegaCompetition = useMemo(() => {
    return competitionId && competitionId === 'e7da5f11a1284d09b10c50e59e4f338e'
  } , [])

  const isStartsCompetitions = useMemo(
    () => competitionId ? [
      "a5acf76614644e068c6fbcdb0b591234", // Анимация, CGI и визуальные эффекты
      "1b34d2608c4b44a4bada28415d6e0ac7", // Гейм-дизайн
      "b6f67510292548a48116544865c413bb", // Дизайн и программирование
      "00503517a6ae494795391cf099b5324f", // Дизайн и продвижение цифрового продукта
      "ce8c14eb587e478bb06af29741749526", // Дизайн и современное искусство
      "86bea52810a74ec5aed370b40c287921", // Коммуникационный дизайн
      "0fb5c9c4152649a1bfad776cc4f1b113", // Дизайн среды и интерьера
      "625a684c2aad45d7ad535ea008be178e", // Игровая графика и концепт-арт
      "35442ed955ba43b78cb04519e0c9eb9e", // Иллюстрация и комикс
      "9a2f9bd90c6c450b816540fd95ddadbf", // Медиа и дизайн
    
      // Москва — Мода
      "e67c65f120a949f6a40e355f8603c889", // Брендинг в индустрии моды
      "e759fe71b56d444ab4567cb73670a7ee", // Дизайн одежды
    
      // Москва — Разработка игр и цифровых продуктов
      "cadb632aa0c0445b928d2266eaba8d48", // Разработка игр и цифровых продуктов
    
      // Санкт-Петербург — Дизайн
      "2fd496b9cf5b4c1292d9a69e5d6c57ee", // Коммуникационный дизайн
      "395f58bdbcac4321a76db6b939633280", // Дизайн среды и интерьера
      "f8e41518de784c03b1f1d8a2ff72f2ee", // Дизайн одежды
      "865c7ac3edb8402e8ed42f55de876941", // Дизайн цифрового продукта
      "099b992943164e578d1eb4e7c95b47b4", // Современная иллюстрация
      "0d605869d89f4540ace34758cb16c8ea", // Communication Design (англ.)
    
      // Санкт-Петербург — Архитектура
      "763e779be98e49b081081911465ed096", // Архитектура
    
      // Нижний Новгород — Дизайн
      "a06d8c9452cd4f5189d5b786dc33714b", // Коммуникационный дизайн
      "21481ea468114610b7bc85575d8b2b09", // UX/UI и frontend-разработка
      "468a5d01f32940d9a77602b4ec64d9d8", // Дизайн среды и интерьера
    
      // Онлайн (Пермь)
      "d638b951f780441ebc30f1fefe335db9", // 3D-постпродакшн
      "57d23b8720374ac7b950958430842364", // Дизайн среды и интерьера
      "f8aed1e5209a4d0d8673c1b23d7a544c", // Дизайн и продвижение цифрового продукта
      "d399519f8c514dc59943e9cce318ac38", // Дизайн и программирование
      "b04fd8720e5443c9ac28f5788e2b146e", // Анимация и иллюстрация
      "8bceccf9f3034982bebd4c8f862e6e2b", // Гейм-дизайн
      "9e08fb787e5943fdb42003722f369380", // Коммуникационный дизайн
      "d29c5182e3d3470eb85de5e34fbf02b4", // Дизайн и современное искусство
      ]
        ?.includes(competitionId) 
    : undefined 
, [competitionId])

    const isArchBookCn = useMemo(
      () => competitionId ? (competitionId === '5f43aa857e134ff38954723e01fcbbb9') : undefined , [competitionId])

    const isNewWorldCompetitions = useMemo(() => {
        return competitionId && competitionId === 'f27288337dbf4989888d800ac226a44f'
    } , [competitionId])
  
    const isSmallShortCompetitions = useMemo(
        () => competitionId ? [
            '1d3562abcb02489bb7b18379aeaf40b9', 
            'e25c7245287548188be20de82b93a365', 
            '111a74097f0948dfb50b5258676fb5d3', 
            '5e0f05e63e8b4122931caf06bf824beb',

            '6de0169b71524f1e907be27c8336f4ec', 
            '320687b8bc604aaab9813a2da2fbb163', 
            '158af43dae6c4874961f5f7687df1619', 
            'e4ad76cc870c4d789515747b34c16c76',
            '65c4b2d0ff4347d5b2aedeed57ea1874']
            ?.includes(competitionId) 
        : undefined 
    , [competitionId])

        const extraFields: CompetitionConsentNames[] = useMemo<CompetitionConsentNames[]>(() => {

          if (isVegaCompetition) {
            return [
              CompetitionConsentNames.AGREE_ONE,
              CompetitionConsentNames.AGREE_TWO,
            ]
          }
            if (isDamuseum) {
              return [
                CompetitionConsentNames.AGREE_ONE,
                CompetitionConsentNames.AGREE_TWO,
                CompetitionConsentNames.AGREE_THREE,
                CompetitionConsentNames.AGREE_FOUR,
                CompetitionConsentNames.AGREE_FIVE,
                CompetitionConsentNames.AGREE_SIX,
                CompetitionConsentNames.CONSENT_FILE,
              ];
            }
          
            if (isSmallShortCompetitions) {
              return [
                CompetitionConsentNames.CONSENT_TO_USE,
                CompetitionConsentNames.CONSENT_TO_DEMONSTRATE,
              ];
            }

            if (isNewWorldCompetitions) {
              return [
                CompetitionConsentNames.AGREE_ONE,
                CompetitionConsentNames.AGREE_TWO,
                CompetitionConsentNames.AGREE_THREE,
              ]
            }
        
            return [
              CompetitionConsentNames.AGREE_ONE,
              CompetitionConsentNames.AGREE_TWO,
              // CompetitionConsentNames.CONSENT_FILE,
            ];
          }, [isDamuseum, isSmallShortCompetitions]);

          useEffect(() => {
            if (isStartsCompetitions) {
              setFields([
                ...commonFields,
                CompetitionInputNames.CITIZENSHIP,
                CompetitionInputNames.FULLNAME,
                CompetitionInputNames.REG_NUMBER,
                CompetitionInputNames.BIRTH_DATE
              ])
            }
            else if (isVegaCompetition) {
              setFields([
                ...commonFields,
                CompetitionInputNames.FULLNAME,
                CompetitionInputNames.EMAIL,
                CompetitionInputNames.PHONE,
                CompetitionInputNames.EDUCATION_PLACE,
                CompetitionInputNames.COURSE_OF_STUDY,
                CompetitionInputNames.PROFILE_OF_STUDY,
                CompetitionInputNames.NOMINATION_NAME,
                CompetitionInputNames.TYPE_OF_AWARD,
                CompetitionInputNames.CITY,
                CompetitionInputNames.COUNTRY,
              ])
            }
            else if (isSmallShortCompetitions) {
              setFields([
                ...commonFields,
                CompetitionInputNames.FULLNAME,
                CompetitionInputNames.EDUCATION_PLACE,
                CompetitionInputNames.EMAIL,
                CompetitionInputNames.PHONE,
                CompetitionInputNames.NOMINATIONS_LIST,
                CompetitionInputNames.PROJECT_NAME_RU,
                CompetitionInputNames.PROJECT_NAME_EN,
                CompetitionInputNames.PROJECT_YEAR,
                CompetitionInputNames.TIMING,
                CompetitionInputNames.CREATE_COUNTRY,
                CompetitionInputNames.ABOUT_RU,
                CompetitionInputNames.ABOUT_EN,
                CompetitionInputNames.HAS_SUBTITLES,
                CompetitionInputNames.VIDEO_LINK,
                CompetitionInputNames.CLOUD_LINK,
              ]);
            } else if (isArchBookCn) {
              setFields([
                ...commonFields,
                CompetitionInputNames.PUBLISHING,
                CompetitionInputNames.AUTHOR,
                CompetitionInputNames.EDITOR,
                CompetitionInputNames.BOOK_NAME,
                CompetitionInputNames.BOOK_YEAR,
                
                CompetitionInputNames.EMAIL,
                CompetitionInputNames.PHONE,

                CompetitionInputNames.WEB_SITE,
                CompetitionInputNames.CONTACT_PERSON,
                CompetitionInputNames.PDF_LINK
              ])
            } else {
              setFields([
                ...commonFields,
                CompetitionInputNames.FULLNAME,
                CompetitionInputNames.EMAIL,
                CompetitionInputNames.PHONE,
                CompetitionInputNames.BIRTH_DATE,
                CompetitionInputNames.EDUCATION_PLACE,
                CompetitionInputNames.CITY,
                CompetitionInputNames.COUNTRY,
              ]);
            }
          }, [
            isArchBookCn,
            isStartsCompetitions,
            isSmallShortCompetitions,
          ]);

    return [fields, extraFields]

}import { useEffect, useMemo, useState } from "react";
import { CompetitionConsentNames, CompetitionInputNames } from "shared/modals/competitionLegalsModal/types";
import { AppTester } from "supporting";

const commonFields = [CompetitionInputNames.PROJECT_ID, CompetitionInputNames.NOMINATION_ID]

export const useCompetitionFormField = (competitionId: string): [CompetitionInputNames[], CompetitionConsentNames[]] => {
    const [fields, setFields] = useState<CompetitionInputNames[]>([

    ])
    const isDamuseum = AppTester.isDaMuseum();

  const isVegaCompetition = useMemo(() => {
    return competitionId && competitionId === 'e7da5f11a1284d09b10c50e59e4f338e'
  } , [])

  const isStartsCompetitions = useMemo(
    () => competitionId ? [
      "a5acf76614644e068c6fbcdb0b591234", // Анимация, CGI и визуальные эффекты
      "1b34d2608c4b44a4bada28415d6e0ac7", // Гейм-дизайн
      "b6f67510292548a48116544865c413bb", // Дизайн и программирование
      "00503517a6ae494795391cf099b5324f", // Дизайн и продвижение цифрового продукта
      "ce8c14eb587e478bb06af29741749526", // Дизайн и современное искусство
      "86bea52810a74ec5aed370b40c287921", // Коммуникационный дизайн
      "0fb5c9c4152649a1bfad776cc4f1b113", // Дизайн среды и интерьера
      "625a684c2aad45d7ad535ea008be178e", // Игровая графика и концепт-арт
      "35442ed955ba43b78cb04519e0c9eb9e", // Иллюстрация и комикс
      "9a2f9bd90c6c450b816540fd95ddadbf", // Медиа и дизайн
    
      // Москва — Мода
      "e67c65f120a949f6a40e355f8603c889", // Брендинг в индустрии моды
      "e759fe71b56d444ab4567cb73670a7ee", // Дизайн одежды
    
      // Москва — Разработка игр и цифровых продуктов
      "cadb632aa0c0445b928d2266eaba8d48", // Разработка игр и цифровых продуктов
    
      // Санкт-Петербург — Дизайн
      "2fd496b9cf5b4c1292d9a69e5d6c57ee", // Коммуникационный дизайн
      "395f58bdbcac4321a76db6b939633280", // Дизайн среды и интерьера
      "f8e41518de784c03b1f1d8a2ff72f2ee", // Дизайн одежды
      "865c7ac3edb8402e8ed42f55de876941", // Дизайн цифрового продукта
      "099b992943164e578d1eb4e7c95b47b4", // Современная иллюстрация
      "0d605869d89f4540ace34758cb16c8ea", // Communication Design (англ.)
    
      // Санкт-Петербург — Архитектура
      "763e779be98e49b081081911465ed096", // Архитектура
    
      // Нижний Новгород — Дизайн
      "a06d8c9452cd4f5189d5b786dc33714b", // Коммуникационный дизайн
      "21481ea468114610b7bc85575d8b2b09", // UX/UI и frontend-разработка
      "468a5d01f32940d9a77602b4ec64d9d8", // Дизайн среды и интерьера
    
      // Онлайн (Пермь)
      "d638b951f780441ebc30f1fefe335db9", // 3D-постпродакшн
      "57d23b8720374ac7b950958430842364", // Дизайн среды и интерьера
      "f8aed1e5209a4d0d8673c1b23d7a544c", // Дизайн и продвижение цифрового продукта
      "d399519f8c514dc59943e9cce318ac38", // Дизайн и программирование
      "b04fd8720e5443c9ac28f5788e2b146e", // Анимация и иллюстрация
      "8bceccf9f3034982bebd4c8f862e6e2b", // Гейм-дизайн
      "9e08fb787e5943fdb42003722f369380", // Коммуникационный дизайн
      "d29c5182e3d3470eb85de5e34fbf02b4", // Дизайн и современное искусство
      ]
        ?.includes(competitionId) 
    : undefined 
, [competitionId])

    const isArchBookCn = useMemo(
      () => competitionId ? (competitionId === '5f43aa857e134ff38954723e01fcbbb9') : undefined , [competitionId])

    const isNewWorldCompetitions = useMemo(() => {
        return competitionId && competitionId === 'f27288337dbf4989888d800ac226a44f'
    } , [competitionId])
  
    const isSmallShortCompetitions = useMemo(
        () => competitionId ? [
            '1d3562abcb02489bb7b18379aeaf40b9', 
            'e25c7245287548188be20de82b93a365', 
            '111a74097f0948dfb50b5258676fb5d3', 
            '5e0f05e63e8b4122931caf06bf824beb',

            '6de0169b71524f1e907be27c8336f4ec', 
            '320687b8bc604aaab9813a2da2fbb163', 
            '158af43dae6c4874961f5f7687df1619', 
            'e4ad76cc870c4d789515747b34c16c76',
            '65c4b2d0ff4347d5b2aedeed57ea1874']
            ?.includes(competitionId) 
        : undefined 
    , [competitionId])

        const extraFields: CompetitionConsentNames[] = useMemo<CompetitionConsentNames[]>(() => {

          if (isVegaCompetition) {
            return [
              CompetitionConsentNames.AGREE_ONE,
              CompetitionConsentNames.AGREE_TWO,
            ]
          }
            if (isDamuseum) {
              return [
                CompetitionConsentNames.AGREE_ONE,
                CompetitionConsentNames.AGREE_TWO,
                CompetitionConsentNames.AGREE_THREE,
                CompetitionConsentNames.AGREE_FOUR,
                CompetitionConsentNames.AGREE_FIVE,
                CompetitionConsentNames.AGREE_SIX,
                CompetitionConsentNames.CONSENT_FILE,
              ];
            }
          
            if (isSmallShortCompetitions) {
              return [
                CompetitionConsentNames.CONSENT_TO_USE,
                CompetitionConsentNames.CONSENT_TO_DEMONSTRATE,
              ];
            }

            if (isNewWorldCompetitions) {
              return [
                CompetitionConsentNames.AGREE_ONE,
                CompetitionConsentNames.AGREE_TWO,
                CompetitionConsentNames.AGREE_THREE,
              ]
            }
        
            return [
              CompetitionConsentNames.AGREE_ONE,
              CompetitionConsentNames.AGREE_TWO,
              // CompetitionConsentNames.CONSENT_FILE,
            ];
          }, [isDamuseum, isSmallShortCompetitions]);

          useEffect(() => {
            if (isStartsCompetitions) {
              setFields([
                ...commonFields,
                CompetitionInputNames.CITIZENSHIP,
                CompetitionInputNames.FULLNAME,
                CompetitionInputNames.REG_NUMBER,
                CompetitionInputNames.BIRTH_DATE
              ])
            }
            else if (isVegaCompetition) {
              setFields([
                ...commonFields,
                CompetitionInputNames.FULLNAME,
                CompetitionInputNames.EMAIL,
                CompetitionInputNames.PHONE,
                CompetitionInputNames.EDUCATION_PLACE,
                CompetitionInputNames.COURSE_OF_STUDY,
                CompetitionInputNames.PROFILE_OF_STUDY,
                CompetitionInputNames.NOMINATION_NAME,
                CompetitionInputNames.TYPE_OF_AWARD,
                CompetitionInputNames.CITY,
                CompetitionInputNames.COUNTRY,
              ])
            }
            else if (isSmallShortCompetitions) {
              setFields([
                ...commonFields,
                CompetitionInputNames.FULLNAME,
                CompetitionInputNames.EDUCATION_PLACE,
                CompetitionInputNames.EMAIL,
                CompetitionInputNames.PHONE,
                CompetitionInputNames.NOMINATIONS_LIST,
                CompetitionInputNames.PROJECT_NAME_RU,
                CompetitionInputNames.PROJECT_NAME_EN,
                CompetitionInputNames.PROJECT_YEAR,
                CompetitionInputNames.TIMING,
                CompetitionInputNames.CREATE_COUNTRY,
                CompetitionInputNames.ABOUT_RU,
                CompetitionInputNames.ABOUT_EN,
                CompetitionInputNames.HAS_SUBTITLES,
                CompetitionInputNames.VIDEO_LINK,
                CompetitionInputNames.CLOUD_LINK,
              ]);
            } else if (isArchBookCn) {
              setFields([
                ...commonFields,
                CompetitionInputNames.PUBLISHING,
                CompetitionInputNames.AUTHOR,
                CompetitionInputNames.EDITOR,
                CompetitionInputNames.BOOK_NAME,
                CompetitionInputNames.BOOK_YEAR,
                
                CompetitionInputNames.EMAIL,
                CompetitionInputNames.PHONE,

                CompetitionInputNames.WEB_SITE,
                CompetitionInputNames.CONTACT_PERSON,
                CompetitionInputNames.PDF_LINK
              ])
            } else {
              setFields([
                ...commonFields,
                CompetitionInputNames.FULLNAME,
                CompetitionInputNames.EMAIL,
                CompetitionInputNames.PHONE,
                CompetitionInputNames.BIRTH_DATE,
                CompetitionInputNames.EDUCATION_PLACE,
                CompetitionInputNames.CITY,
                CompetitionInputNames.COUNTRY,
              ]);
            }
          }, [
            isArchBookCn,
            isStartsCompetitions,
            isSmallShortCompetitions,
          ]);

    return [fields, extraFields]

}